<dgx-popover
  [(isOpen)]="isOpen"
  [popoverTrigger]="popoverTrigger"
  [popoverArrowHidden]="true"
  (isOpenChange)="onPopoverOpenChange($event)"
>
  <dgx-search-field-wrapper class="full-width" iconSize="small" type="squared">
    <input
      #searchInput
      type="text"
      class="guts-p-v-1"
      [(ngModel)]="searchTerm"
      (input)="onSearch($event)"
      (keydown)="onInputKeydown($event)"
      autocomplete="off"
      role="listbox"
      [attr.aria-label]="i18n.DashboardNav_SearchBySkill"
      [placeholder]="i18n.DashboardNav_SearchBySkill"
      data-dgat="quick-add-focus-skill-popover-010"
    />
  </dgx-search-field-wrapper>
  <p class="par--light_a par--small guts-p-h-1 guts-p-t-1" *ngIf="emptySearch">
    {{ i18n.OrgSkills_NoSkillsResultsFound }}
  </p>
  <div class="scrollable __search-menu guts-p-t-half" role="menu" #skillList>
    <df-spinner *ngIf="!isLoaded"></df-spinner>
    <button
      *ngFor="let skill of skills; trackBy: trackById"
      class="listbox--option guts-p-v-half"
      (click)="onSelectItem(skill)"
      data-dgat="quick-add-focus-skill-popover-6dd"
      role="menuitem"
    >
      <span [class.color-ebony]="emptySearch">{{ skill.title }}</span>
      <img
        class="__endorsed-img"
        *ngIf="skill.isEndorsed && endorsedSrc"
        [src]="endorsedSrc"
        [attr.alt]="i18n.Core_Endorsed"
        [attr.aria-label]="i18n.OrgSkills_EndorsedSkillTooltip"
      />
    </button>
  </div>
</dgx-popover>
